///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.login = abcsetup.login || {};
abcsetup.login.password = abcsetup.login.password || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.login.password = {
    init: function() {
        abcsetup.setTitle('Login');

        // Get the user's timezone
        $('#timezone').val(moment.tz.guess());

        // Init reCAPTCHA login
        abcsetup.recaptcha.init('login');

        // Bind the update form submit event
        $('#password_frm').on('submit', function() {
            $(':button[type="submit"]').prop('disabled', true).addClass('disabled');
            $('input[type="password"]').addClass('disabled');
        });
    },
}